import * as React from 'react';
import { usePrelandingProps } from '../../hooks/usePrelandingProps';
import { ConsultationTrap } from '../../components/ConsultationTrap';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { trackBannerShow } from './tracking';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { CpdConsultationExperiment } from './experiment';

export const ConsultationTrapContainer: React.FC = () => {
  const experimentGroup = CpdConsultationExperiment.use();
  const isDesktop = useIsDesktop();
  const { handleBannerClick } = usePrelandingProps();

  if (experimentGroup !== 'B') {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={() => trackBannerShow('CpdConsultationBanner')}>
      <ConsultationTrap isDesktop={isDesktop} onCLick={() => handleBannerClick('CpdConsultationBanner')} />
    </ActionAfterViewObserver>
  );
};
